import * as ErrorAction from "./ErrorAction";

export default function errorReducer(state = {}, action) {
    const {type, error, payload} = action;

    switch (type) {
        case ErrorAction.REMOVE_BY_ID:
            return Object.entries(state).reduce((newState, [key, value]) => {
                if (value.id !== payload) {
                    newState[key] = value;
                }
                return newState;
            }, {});
        case ErrorAction.REMOVE_BY_TYPE:
            return Object.entries(state).reduce((newState, [key, value]) => {
                if (key !== payload) {
                    newState[key] = value;
                }
                return newState;
            }, {});
        case ErrorAction.CLEAR_ALL:
            return {};
        default: {
            // True if the action type has the key word '_FINISHED' then the action is finished.
            const isFinishedRequestType = type.includes("_FINISHED");
            // True if the action type has the key word 'REQUEST_' and not '_FINISHED'.
            const isStartRequestType = type.includes("REQUEST_") && !isFinishedRequestType;

            // If an action is started we want to remove any old errors because there is a new action has been re-dispatched.
            if (isStartRequestType) {
                // Using ES7 Object Rest Spread operator to omit properties from an object.
                const {[`${type}_FINISHED`]: value, ...stateWithoutFinishedType} = state;
                return stateWithoutFinishedType;
            }

            // True if the action is finished and the error property is true.
            const isError = isFinishedRequestType && Boolean(error);

            if (isError === false) {
                return state;
            }

            /*
            * At this point the "type" will be a finished action type (e.g. "SomeAction.REQUEST_*_FINISHED").
            * The payload will be a HttpErrorResponseModel.
            */
            return {
                ...state,
                [type]: payload,
            };
        }
    }
}
